// v-count: animate a number from 0 to its value when it scrolls into view.
//
// Reads the target from the elementʼs text (e.g. "39 283") or the binding value,
// preserves any prefix/suffix (e.g. "+", "%"), formats with space thousands
// separators, and counts up over 2s. Dates and non-numeric text are left alone.
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const reduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

const group = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
const tweens = new WeakMap()

const count = {
  mounted(el, binding) {
    const raw = binding.value != null ? String(binding.value) : el.textContent || ''
    const match = raw.match(/\d[\d\s.,]*/)
    if (!match) return // nothing numeric to animate
    const numStr = match[0]
    const target = parseInt(numStr.replace(/\D/g, ''), 10)
    if (!Number.isFinite(target)) return
    const prefix = raw.slice(0, match.index)
    const suffix = raw.slice(match.index + numStr.length)
    const render = (v) => (el.textContent = prefix + group(v) + suffix)

    if (reduced) {
      render(target)
      return
    }

    render(0)
    const obj = { n: 0 }
    const tween = gsap.to(obj, {
      n: target,
      duration: 2,
      ease: 'power1.out',
      onUpdate: () => render(Math.round(obj.n)),
      scrollTrigger: { trigger: el, start: 'top 92%', once: true },
    })
    tweens.set(el, tween)
  },
  unmounted(el) {
    const t = tweens.get(el)
    if (t) {
      if (t.scrollTrigger) t.scrollTrigger.kill()
      t.kill()
      tweens.delete(el)
    }
  },
}

export default count
